const initialState = {
  loading: false,
  loadingCmt: false,
  schForm: {
    pg: 1,
    pgSz: 10,
    schStore: "",
    schTp: "",
  },
  winnerList: "",
  eventList: "",

  //event
  evtForm: {
    seq: "",
    storeCode: "",
    mode: "",
    schTp: "",
  },
  event: "",
  winSeq: "",
  winner: "",
  cmForm: {
    pg: 1,
    pgSz: 10,
    evSeq: "",
  },
  commentList: "",
};

export const INIT = "INIT";
export const init = () => ({
  type: INIT,
});

export const LOADING = "LOADING";
export const loadingAction = (data) => ({
  type: LOADING,
  payload: data,
});

export const INIT_EVENT = "INIT_EVENT";
export const initEventAction = (data) => ({
  type: INIT_EVENT,
  payload: data,
});

export const LOADING_COMMENT = "LOADING_COMMENT";
export const loadingCommentAction = (data) => ({
  type: LOADING_COMMENT,
  payload: data,
});

export const LOAD_EVENT_LIST = "LOAD_EVENT_LIST";
export const loadEventListAction = (data) => ({
  type: LOAD_EVENT_LIST,
  payload: data,
});

export const SET_FORM = "SET_FORM";
export const schFormAction = (data) => ({
  type: SET_FORM,
  payload: data,
});

export const LOAD_LIST_SUCCESS = "LOAD_LIST_SUCCESS";
export const loadListSuccessAction = (data) => ({
  type: LOAD_LIST_SUCCESS,
  payload: data,
});

export const LOAD_WINNER_LIST = "LOAD_WINNER_LIST";
export const loadWinnerListAction = (data) => ({
  type: LOAD_WINNER_LIST,
  payload: data,
});

export const LOAD_WINNER_LIST_SUCCESS = "LOAD_WINNER_LIST_SUCCESS";
export const loadWinnerListSuccessAction = (data) => ({
  type: LOAD_WINNER_LIST_SUCCESS,
  payload: data,
});

export const LOAD_EVENT = "LOAD_EVENT";
export const loadEventAction = (data) => ({
  type: LOAD_EVENT,
  payload: data,
});

export const RESET_EVENT = "RESET_EVENT";
export const resetEvent = () => ({
  type: RESET_EVENT,
  payload: initialState,
});

export const LOAD_EVENT_SUCCESS = "LOAD_EVENT_SUCCESS";
export const loadEventSuccessAction = (data) => ({
  type: LOAD_EVENT_SUCCESS,
  payload: data,
});

export const LOAD_WINNER = "LOAD_WINNER";
export const loadWinnerAction = (data) => ({
  type: LOAD_WINNER,
  payload: data,
});

export const LOAD_WINNER_SUCCESS = "LOAD_WINNER_SUCCESS";
export const loadWinnerSuccessAction = (data) => ({
  type: LOAD_WINNER_SUCCESS,
  payload: data,
});

export const LOAD_COMMENT_LIST = "LOAD_COMMENT_LIST";
export const loadCommentListAction = (data) => ({
  type: LOAD_COMMENT_LIST,
  payload: data,
});

export const LOAD_COMMENT_LIST_SUCCESS = "LOAD_COMMENT_LIST_SUCCESS";
export const loadCommentListSuccessAction = (data) => ({
  type: LOAD_COMMENT_LIST_SUCCESS,
  payload: data,
});

export default function eventReducer(state = initialState, action) {
  const { type, payload, error } = action;
  console.log("payload", payload);
  switch (type) {
    case INIT:
      return {
        ...initialState,
      };
    case SET_FORM:
      return {
        ...state,
        schForm: payload,
      };
    case LOADING:
      return {
        ...state,
        loading: payload,
      };
    case LOADING_COMMENT:
      return {
        ...state,
        loadingCmt: payload,
      };
    case INIT_EVENT:
      return {
        ...initialState,
      };
    case LOAD_EVENT:
      return {
        ...state,
        evtForm: payload,
      };
    case LOAD_EVENT_SUCCESS:
      return {
        ...state,
        event: payload,
      };
    case LOAD_EVENT_LIST:
      return {
        ...state,
        schForm: payload,
      };
    case LOAD_LIST_SUCCESS:
      return {
        ...state,
        eventList: payload,
      };
    case LOAD_WINNER_LIST:
      return {
        ...state,
        schForm: payload,
      };
    case LOAD_WINNER_LIST_SUCCESS:
      return {
        ...state,
        winnerList: payload,
      };
    case LOAD_WINNER:
      return {
        ...state,
        winSeq: payload,
      };
    case LOAD_WINNER_SUCCESS:
      return {
        ...state,
        winner: payload,
      };
    case LOAD_COMMENT_LIST:
      return {
        ...state,
        cmForm: payload,
      };
    case LOAD_COMMENT_LIST_SUCCESS:
      return {
        ...state,
        commentList: payload,
      };
    case RESET_EVENT:
      return {
        ...state,
        event: "",
      };
    default:
      return state;
  }
}
